<template>

<div class="role" v-if="item.count">

    <div class="role-capacity">
        <div class="role-filled" :style="{width: progressWidth}" />
    </div>

</div>

</template>

<script>

export default {

	props: ['item'],

    computed: {
    
        progressWidth: function() {
        
            var percent = (this.item.count.capacity) ? (100 / this.item.count.capacity) * this.item.count.filled : 0
            
            if(percent > 100) percent = 100

            return percent.toString() + '%'
        
        }
    
    }

}

</script>

<style scoped>

.role {
    padding-top: 2px;
}

.role-capacity {
    border-radius: 4px;
    width: 100%;
    height: 10px;
    background-color: #ddd;
}

.role-filled {
    border-radius: 4px;
    height: 10px;
	background-color: #4082d3;
}

</style>
